import React, { useEffect } from "react";
// import "./orderTable.css";
import styled from "@emotion/styled";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    maxWidth: "45rem",
    // height: "18.5rem",
    // overflowY: "scroll",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const PdfCurrentOrdersTableData = ({
  maxWidth = "60rem",
  orderProducts,
  total,
}) => {
  return (
    <div>
      <TableContainer maxWidth={maxWidth}>
        <table className="main-table">
          <tr className="table-rows">
            <th className="table-heads color_262c3d" width={"14%"}>
              Product Name
            </th>
            <th className="table-heads" width={"10%"}>
              Division
            </th>
            <th className="table-heads" width={"5%"}>
              Qty
            </th>
            <th className="table-heads" width={"5%"}>
              Free Qty
            </th>
            <th className="table-heads" width={"8%"}>
              Price
            </th>
          </tr>
          {orderProducts?.length > 0 &&
            orderProducts.map((ele, index) => (
              <tr className="table-rows1" key={index}>
                <td className="table-each-row-data">
                  {ele?.product?.product_name}
                </td>
                <td className="table-each-row-data">{ele?.vendorDivision?.name}</td>
                <td className="table-each-row-data">{ele?.quantity}</td>
                <td className="table-each-row-data">
                  {ele?.offer ? ele?.offer_qty : "--"}
                </td>
                <td className="table-each-row-data">₹ {parseFloat(ele?.price).toFixed(2)}</td>
              </tr>
            ))}
        </table>
      </TableContainer>
      <TableFooter
        className="d-flex justify-content-between align-items-center px-4 table-footer"
        maxWidth={maxWidth}
      >
        <div>
          <label className="text-white ">Total</label>
        </div>
        <div>
          <label className="text-white fw_600 mx-5">₹ {total}</label>
        </div>
      </TableFooter>
    </div>
  );
};

export default PdfCurrentOrdersTableData;